<template>
  <div class="p-5">
    <h3>About Anywords</h3>
    <hr><br><br>
    <p>
      Anyword is just a simple site that allow you to make a post by type anything on a field. it will post it and everyone can read it.
      You can contact me on bayusulistyo16@gmail.com.
      <b>Thank You</b>
    </p>
  </div>
</template>

<style scoped>
hr {
      border: 0;
      height: 1px;
      width:30%;
      float:left;
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
  }
</style>

<script>
export default {

};
</script>
